import { z } from "zod";
import { zodDayjs } from "../utils/zodHelpers";

export const FormSaveRequestFieldSchema = z.object({
  fieldAlias: z.string(),
  value: z.any().nullish(),
});

export type FormSaveRequestField = z.infer<typeof FormSaveRequestFieldSchema>;

export const FormSaveRequestSchema = z.object({
  formId: z.number(),
  values: z.array(FormSaveRequestFieldSchema),
});

export type FormSaveRequest = z.infer<typeof FormSaveRequestSchema>;

const FormFieldSchema = z.object({
  id: z.number(),
  name: z.string(),
  type: z.string(),
});

export type FormField = z.infer<typeof FormFieldSchema>;

export const FormGetFieldSchema = z.object({
  fieldAlias: z.string(),
  value: z.any().nullish(),
});

export type FormGetField = z.infer<typeof FormGetFieldSchema>;

const FormGetResponseSchema = z.object({
  formId: z.number(),
  clientFormId: z.number(),
  patientId: z.number(),
  modifyDateTime: zodDayjs,
  values: z.array(FormGetFieldSchema),
});

export type FormGetResponse = z.infer<typeof FormGetResponseSchema>;

export const FormsGetResponseSchema = z.array(FormGetResponseSchema);

export type FormsGetResponse = z.infer<typeof FormsGetResponseSchema>;
